export var customJsApiRelativePath = "/helpcenter/snippets/js";
export var customJsApiRelativePathV2 = "/helpcenter/snippets/js/v2";
export var createCustomJsApi = function (baseUrl, http) {
    var apiUrl = "".concat(baseUrl).concat(customJsApiRelativePath);
    var apiUrlV2 = "".concat(baseUrl).concat(customJsApiRelativePathV2);
    return {
        getCustomJs: function (brandId) {
            return http.get("".concat(apiUrl).concat(brandId ? "?brandId=".concat(brandId) : ''));
        },
        updateCustomJs: function (dto) { return http.put("".concat(apiUrl), dto.data); },
        getCustomJsV2: function (brandId) {
            return http.get("".concat(apiUrlV2).concat(brandId ? "?brandId=".concat(brandId) : ''));
        },
        updateCustomJsV2: function (dto) { return http.put("".concat(apiUrlV2), dto.data); },
    };
};
//# sourceMappingURL=index.js.map